import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
const VisualArts = () => {
  const homeMenu = [
    {
      label: "Curriculum",
      link: "",
      subMenu: [
        { label: "Primary Wing", link: "/primarywing" },
        { label: "Middle Wing", link: "/middleWing" },
        { label: "Senior Wing", link: "/seniorWing" },
        { label: "Curriculum", link: "/curriculum" },
      ],
    },

    {
      label: "Extended Classroom",
      link: "",
      subMenu: [
        { label: "Labs", link: "/mathmatics" },
        { label: "Excursions", link: "/excursions" },
        { label: "Library", link: "/library" },
        { label: "Field Trips", link: "/feildTrip" },
        { label: "Astronomy", link: "/astronomy" },
      ],
    },
    {
      label: "Sports",
      link: "",
      subMenu: [
        { label: "Sports", link: "/sports" },
        {
          label: "Achievements in Sports 2022-23",
          link: "/acheivementInSports",
        },
      ],
    },
    {
      label: "Arts",
      link: "",
      subMenu: [
        { label: "Performing Arts", link: "/music" },
        { label: "Visual Arts", link: "/visualArts" },
      ],
    },

    { label: "Houses", link: "/houses" },
    { label: "Assembly", link: "/assembly" },
    { label: "Book List", link: "/booklist" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-art.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Visual Arts"
                breadEnd="Learning Approach"
                breadMid="Visual Arts"
              />
            </div>
          </div>
          <div className="row ">
            <div className="col-xl-12 mb-4">
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/art-and-craft.jpg"
                  className="float-end wid-500 m-2"
                  alt="Lotus Valley Gurgaon"
                />
              </LazyLoad>
              <p>
                Experiencing and creating works of art benefits students in
                their intellectual, personal and social development. At Lotus
                Valley, we view art as a means of connecting with our
                surroundings. We recognize the important role of art in almost
                all aspects of education: from creativity to interpretation;
                from discussion to understanding design. Our art studios are
                sagas by themselves. Our faculties are well trained to unravel
                each child's inherent talent, guiding them through various
                techniques and discovering the artist in them. In the visual
                arts classes, our learners are taught various art forms and
                techniques besides creating artworks using waste and recyclable
                material.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default VisualArts;
